












































































































































































































































import 'reflect-metadata'
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import DialogNoteOnColumn from '@/components/common/data-table/DialogNoteOnColumn.vue'
import { MasterDataApi, BankApi } from "@/api"
import { IDataTableTransferPlanning } from "@/resource/planning-cr/ModifyJsonData"
import DatePickerOnColumn from "@/components/planning/DatePickerOnColumn.vue"

@Component({
    components: { 
        'common-data-table-dialog-note-column': DialogNoteOnColumn,
        DatePickerOnColumn
    }
})
export default class BankDialog extends Vue { 
    @Prop(Function) public updateBankLists: any
    @Prop(Function) public notifcation: any
    @Prop(Function) public openNotification: any
    // @Ref() readonly noOrder!: any

    dialogBank = false
    items: any[] = []
    loading = false
    switchBankUse = [] as any
    headers = [
        { text: "ใช้", value: "bankUse", width: 20 ,sortable: false, align: "start" },
        { text: "ลำดับ", value: "noOrder", width: 100 ,sortable: false, align: "center" },
        { text: "ธนาคาร", value: "bankId", width: 340 ,sortable: false },
        { text: "วันที่ยื่นกู้", value: "recoverDate", width: 200 ,sortable: false },

        { text: "วงเงินอนุมัติ", value: "approveFinanceAmt", width: 150 ,sortable: false },
        { text: "อัตราดอกเบี้ย", value: "interest", width: 300 ,sortable: false },
        { text: "อนุมัติ%", value: "approveCreditPercent", width: 150 ,sortable: false },
        { text: "วันที่อนุมัติ", value: "approveDate", width: 200 ,sortable: false },

        { text: "สถานะสินเชื่อ", value: "creditStatusId", width: 200 ,sortable: false },
        { text: "เหตุผลสถานะสินเชื่อ", value: "creditReasonStatusId", width: 340, sortable: false },
        { text: "หมายเหตุธนาคาร	", value: "crRemarkBank", width: 500, sortable: false },
        { text: "ลบ", value: "actionRemove", width: 30, sortable: false },
    ]
    unitCode = "" as any
    unitId = 0 as any
    masterBankLists = [] as any
    creditStatusLists = [] as any
    creditReasonStatusLists = [] as any
    // $refs = {} as any
    bankCount: number = 0

    formatNumber(value: string ): string {
        const num = Number(value);
        return num.toLocaleString('en-US', {minimumFractionDigits: 0 });
    }

    isNumber (evt: KeyboardEvent): void {
    const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ','];
    const keyPressed: string = evt.key;

    console.log(" Key Pressed : ", keyPressed);
        if (!keysAllowed.includes(keyPressed)) {
            evt.preventDefault()
        }
    }

    preventPaste(event: ClipboardEvent, item: any) {
        const clipboardData = event.clipboardData || (window as any).clipboardData;
        let pastedData = clipboardData.getData('Text');
        
        let newValue = pastedData.split('.')[0].replace(/,/g, '');
        
        for (let i = 0; i < newValue.length; i++) {
            if (!/[0-9]/.test(newValue[i])) {
                event.preventDefault();
                return;
            }
        }
        pastedData = newValue.replace(/[^\d]/g, '');
        item.approveFinanceAmt = newValue;

        event.preventDefault();
    }

    updateApproveFinanceAmt(item: any, newValue: string) {
        let parsedValue = parseInt(newValue.replace(/[^0-9]/g, ''), 10);
        
        if (!isNaN(parsedValue)) {
            item.approveFinanceAmt = parsedValue.toString();
        } else {
            console.warn('Invalid input:', newValue);
        }
    }

    async openDialog (item: IDataTableTransferPlanning, tempBankLists: any[]) {
        console.log("-> item", item  )
        console.log("-> tempBankLists", tempBankLists)
        this.loading = true
        this.dialogBank = true
        this.unitCode = item.unitCode
        this.unitId = item.unitId
        await this.getMaster()
    

        if (tempBankLists.length === 0) {
            this.items = await BankApi.GetTransferPlanningBankByUnitIdAndTransferId(`${item.unitId}`, `${item.bookingId}`, `${item.transferId}`)
        } else {
            this.items = await tempBankLists[0].bankLists
        }
        this.bankCount = this.items.length

        this.items = this.items.map(m => {
            let getBank = this.masterBankLists.filter((b: any) => b.id == m.bankId)
            if (getBank.length > 0) m.bankId = getBank[0]
            return m
        })
        
        if (this.items.length > 0) {
            const useBankId = this.items.filter((f: any) => f.bankId.id === this.items[0].usedBankId)
            // if (useBankId.length > 0) {
            //     this.switchBankUse = [useBankId[useBankId.length - 1].id]
            // } else {
            //     this.switchBankUse = []
            // }
            this.switchBankUse = useBankId.length > 0 ? [useBankId[useBankId.length - 1].id] : [];
        } else {
            this.switchBankUse = []
        }
        this.loading = false
    }

    closeDialog () {
        this.dialogBank = false
    }

    async getMaster () {
        this.masterBankLists = await MasterDataApi.GetMasterDataBank()
        this.creditStatusLists = await MasterDataApi.GetMasterDataVlookUptpl1ByType("CreditStatus")
        this.creditReasonStatusLists = await MasterDataApi.GetMasterDataCreditReasonStatusByCreditStatusId(3)
    }

    getMasterBankList (bankData: any) {
        if (bankData == undefined)
        {
            let getBankNoId = this.masterBankLists.filter( (x: any) => x.active == true)
            return getBankNoId
        }
        else
        {
            let getBankYesId = this.masterBankLists.filter( (x: any) => x.id == bankData.id || x.active == true)
            return getBankYesId
        }
        
    }

    getFilteredCreditStatusLists(item: any) {
    // 2. ดึงรายการที่ flagActive เป็น 1 จาก relatedItems
    const activeItems =  this.creditStatusLists.filter((x: any) => x.flagActive === 1);

    // 3. หาค่าเก่าที่ถูกเลือกไว้ของแต่ละ item
    const selectedItem = this.creditStatusLists.find((x: any) => x.id === item.creditStatusId);

    // 4. สร้าง Set เพื่อรวมรายการที่ active และรายการเก่า (ถ้ามี) เข้าด้วยกัน
    const combinedItems = new Set(activeItems);
    if (selectedItem) {
    combinedItems.add(selectedItem);
    }

    // 5. แปลง Set กลับเป็น Array โดยไม่ต้องเรียงลำดับ
    return [...combinedItems];
    }

    // ** ฟังก์ชันที่แก้ไขแล้ว **
    getFilteredCreditReasonStatusLists(item: any) {
    // 1. ดึงรายการที่มี idLevel1 ตรงกับ creditStatusId ของแต่ละ item
    const relatedItems = this.creditReasonStatusLists.filter((x: any) => x.idLevel1 == item.creditStatusId);

    // 2. ดึงรายการที่ flagActive เป็น 1 จาก relatedItems
    const activeItems = relatedItems.filter((x: any) => x.flagActive === 1);

    // 3. หาค่าเก่าที่ถูกเลือกไว้ของแต่ละ item
    const selectedItem = relatedItems.find((x: any) => x.id === item.creditReasonStatusId);

    // 4. สร้าง Set เพื่อรวมรายการที่ active และรายการเก่า (ถ้ามี) เข้าด้วยกัน
    const combinedItems = new Set(activeItems);
    if (selectedItem) {
    combinedItems.add(selectedItem);
    }

    // 5. แปลง Set กลับเป็น Array โดยไม่ต้องเรียงลำดับ
    return [...combinedItems];
    }

    async openDialogAdd () {
        console.log('openDialogAdd')
        this.items.push({
            id: Math.floor(Math.random() * 999999),
            unitId: this.unitId,
            bankId: null,
            recoverDate: "",
            usedBankId: 0,
            approveFinanceAmt: "",
            interest: "",
            approveCreditPercent: "",
            approveDate: "",
            creditStatusId: 0,
            creditReasonStatusId: 0,
            crRemarkBank: "",
            noOrder: "",
            bankName: "",
        })
    }

    changeBankUse (item: any) {
        if (this.switchBankUse.length > 0) {
            this.switchBankUse = [item.id]
        } else {
            this.switchBankUse = []
        }
    }

    changeBankId (item: any) {
        this.switchBankUse = []
    }

    btnRemoveBank (id: number) {
        console.log('btnRemoveBank', id)
        console.log('bankCount', this.bankCount)
        this.items = this.items.filter(x => x.id !== id)
    }

    async btnSaveDraft () {
        if (this.items.length === 0 && this.bankCount === 0) {
            this.dialogBank = false
            return
        }

        //remove bank all
        if (this.items.length === 0 && this.bankCount != 0) {
            this.updateBankLists({
                unitId: this.unitId,
                bankIdUse: "",
                bankNameUse: "",
                bankLists: [{
                    id: 0,
                    unitId: 0,
                    bankId: 0,
                    recoverDate: "",
                    usedBankId: 0,
                    approveFinanceAmt: "",
                    interest: "",
                    approveCreditPercent: "",
                    approveDate: "",
                    creditStatusId: 0,
                    creditReasonStatusId: 0,
                    crRemarkBank: "",
                    noOrder: 0,
                    deleteAll: true
                }],
               
            })
            this.dialogBank = false
            return
        }

        if (!this.validateColumnDataTable()) {
            return
        }

        let bankIdUse: any
        let bankNameUse = ""
        if (this.switchBankUse.length > 0) {
            let bankDetail: any = this.items.filter(b => b.id === this.switchBankUse[0])[0].bankId
            bankIdUse = bankDetail.id
            bankNameUse = bankDetail.name
        }
        
        const item = JSON.parse(JSON.stringify(this.items))
        const bankLists = item.map((x: IBank) => {
            x.usedBankId = bankIdUse
            let bankId: any = x.bankId
            x.bankId = bankId.id
            x.deleteAll = false
            return x
        })
        
        this.updateBankLists({
            unitId: this.unitId,
            bankIdUse: bankIdUse,
            bankNameUse: bankNameUse,
            bankLists: bankLists,
        } as IBankDetails)
        
        this.dialogBank = false
    }

    formatNumberOnBlur(item: any) {
        const value = item.approveFinanceAmt;
        const cleanedValue = value.replace(/,/g, '').trim();
        
        if (cleanedValue !== '') {
            const formattedValue = parseInt(cleanedValue);
            item.approveFinanceAmt = formattedValue;
        }
    } 

    validateColumnDataTable () {
        if (this.items.length === 0) {
            this.notifcation('ยังไม่มีข้อมูลในการบันทึก', "warning")
            return false
        }

        if (this.switchBankUse.length === 0) {
            this.notifcation('กรุณาเลือกใช้ธนาคารสินเชื่อ', "warning")
            return false
        }

        const emptyColumn = this.items.filter(x => x.noOrder === "" || x.bankId === "" || x.bankId === null || x.bankId === 0 || x.creditStatusId === 0 || x.creditReasonStatusId === 0 || x.noOrder <= 0)
        if (emptyColumn.length > 0) {
            this.notifcation('กรุณากรอกข้อมูลที่จำเป็นใน highlight สีแดง', "warning")
            return false
        }

        let items = this.items.map(function(item){ return item.noOrder });
        var isDuplicate = items.some(function(item, idx){ 
            return items.indexOf(item) != idx 
        })
        if (isDuplicate) {
            this.notifcation('ไม่สามารถตั้งลำดับให้ซ้ำกันได้', "warning")
            return false
        }

        let itemsBank = this.items.map(function(item){ return item.bankId });
        var isDuplicateBank = itemsBank.some(function(item, idx){ 
            return itemsBank.indexOf(item) != idx 
        })
        if (isDuplicateBank) {
            this.notifcation('ไม่สามารถเลือกธนาคารซ้ำกันได้', "warning")
            return false
        }

        const amountNotNumber = this.items.filter(x => 
            isNaN(Number(x.approveFinanceAmt))
        );

        if (amountNotNumber.length > 0) {
            this.notifcation('กรุณาตรวจสอบ วงเงินอนุมัติ', "warning");
            return false;
        }

        const emptyApproveDate = this.items.filter(x => x.recoverDate === "" && x.approveDate != "")
        if (emptyApproveDate.length > 0) {
            let noOrder = emptyApproveDate[0].noOrder
            this.notifcation('กรุณากรอก วันที่ยื่นกู้ ของธนาคารลำดับที่ ' + noOrder, "warning")
            return false
        }

        const checkRecoverAndApproveDate = this.items.filter(x => x.recoverDate != "" && x.approveDate != "")
        const checkNew = checkRecoverAndApproveDate.filter(x => x.recoverDate > x.approveDate)
        if (checkNew.length > 0) {
            let noOrder = checkNew[0].noOrder
            this.notifcation('กรุณากรอก วันที่ยื่นกู้ให้น้อยกว่าหรือเท่ากับ วันที่อนุมัติ ของธนาคารลำดับที่ ' + noOrder, "warning")
            return false
        }

        return true
    }

    dialogColumnCRRemarkBank (item: IDataTableTransferPlanning) {
		const refDialogNoteOnColumn = this.$refs.refDialogNoteOnColumn as DialogNoteOnColumn
        refDialogNoteOnColumn.openDialog(item, `${this.unitCode} : หมายเหตุธนาคาร`, "crRemarkBank")
	}

    changeStateTableItem (tableItem: any) {
        this.items.filter(x => x.unitId === tableItem.unitId)[0] = tableItem
    }

}

export interface IBankDetails {
    unitId: number
    bankIdUse: string
    bankNameUse: string
    bankLists: IBank[]
}

export interface IBank {
    id: number
    unitId: number
    bankId: number
    recoverDate: string
    usedBankId: number
    approveFinanceAmt: string
    interest: string
    approveCreditPercent: string
    approveDate: string
    creditStatusId: number
    creditReasonStatusId: number
    crRemarkBank: string
    noOrder: number
    deleteAll: boolean
}


